export default ["Male", "Female", "Other"];
